<template>
  <div>
    <b-overlay id="mainOverlay" :show="true" rounded="sm">
      <div style="position: relative;  height: 100vh; width: 100%; display: table;"></div>
    </b-overlay>
    <div id="mainRouterView" style="display: none">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "App",
  data() {
    return {
      colore: "#01BAEF"
    };
  },
  onIdle() {
    Cookies.remove("loginToken");
    this.$router.go();
  }
};
</script>

<style>
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/css/font-awesome.min.css";
/* Import Bootstrap Vue Styles */
/* @import "~bootstrap-vue/dist/bootstrap-vue.css"; */
@import "~bootstrap/dist/css/bootstrap.css";
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>
<style lang="scss">
// Import Main styles for this application
@import "./scss/style";

//https://coolors.co/20bf55-0b4f6c-01baef-fbfbff-757575

#nprogress .bar {
  height: 6px;
}
.card {
  background-color: #e7f8fd !important;
  border-style: solid !important;
  border-width: 1px !important;
  .card-header {
    background-color: #013a6b !important; //#89c1e9; // <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
    color: #fbfbff !important;
    font-weight: 600 !important;
    text-transform: uppercase;
    div {
      padding: 0.75rem 1.25rem !important;
    }
  }
}
.app-header.navbar {
  background-color: #20bf55; //#89c1e9;
}

body {
  background-color: #fbfbff !important;
}

.sidebar {
  background-color: #0b4f6c; //#0B4F6C;
}

.app-header.navbar .navbar-brand {
  background-color: #fbfbff; //!important
  width: 250px !important;
}

.el-collapse-item,
.el-collapse-item__header,
.el-collapse-item__content,
.el-collapse-item__wrap {
  background-color: transparent !important;
}

.sidebar .nav-link i,
.sidebar .navbar .dropdown-toggle i,
.navbar .sidebar .dropdown-toggle i {
  color: #20bf55; //!important;
}

.sidebar .nav-link.active i,
.sidebar .navbar .active.dropdown-toggle i,
.navbar .sidebar .active.dropdown-toggle i {
  color: #fbfbff; //!important;
}

.k-widget {
  font-size: inherit !important;
}

a.open > i {
  color: white !important;
}

a.open > div > i {
  color: white !important;
}

.btn-default {
  background-color: #0b4f6c !important;
  border-radius: 2px !important;
  color: white !important;
  text-transform: uppercase;
  margin: 2px;
}

.tooltip {
  display: block !important;
  z-index: 10000;
  .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
  }
  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
  }
  &[x-placement^="top"] {
    margin-bottom: 5px;
    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  &[x-placement^="bottom"] {
    margin-top: 5px;
    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }
  &[x-placement^="right"] {
    margin-left: 5px;
    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[x-placement^="left"] {
    margin-right: 5px;
    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
  &[aria-hidden="true"] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }
  &[aria-hidden="false"] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
  &.info {
    $color: rgba(#004499, 0.9);
    .tooltip-inner {
      background: $color;
      color: white;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }
    .tooltip-arrow {
      border-color: $color;
    }
  }
  &.popover {
    $color: #f9f9f9;
    .popover-inner {
      background: $color;
      color: black;
      padding: 24px;
      border-radius: 5px;
      box-shadow: 0 5px 30px rgba(black, 0.1);
    }
    .popover-arrow {
      border-color: $color;
    }
  }
}

/* per CIPRIANI */

.card-body,
.card-block {
  padding: 1rem !important;
}
</style>
